import { Flex, Text } from '@chakra-ui/react';

import { tracking } from '#features/analytics';
import { Link } from '#features/routing';
import { Button } from '#features/ui';

type InlineCtaProps = {
  title: string;
  buttonLabel: string;
  accentColor: string;
};

/**
 * Lightweight mid-page CTA - a short prompt + button at natural decision points,
 * so a convinced visitor doesn't have to scroll to the final CTA. Borderless on
 * purpose, to stay distinct from the final card CTA.
 */
export const InlineCta = ({ title, buttonLabel, accentColor }: InlineCtaProps) => (
  <Flex
    direction={{ base: 'column', sm: 'row' }}
    alignItems="center"
    justifyContent="center"
    gap={{ base: 4, sm: 6 }}
    textAlign={{ base: 'center', sm: 'left' }}
  >
    <Text fontSize={{ base: 'lg', md: 'xl' }} fontWeight="800" maxW="440px" lineHeight="1.25">
      {title}
    </Text>
    <Button
      size="lg"
      minW="210px"
      flexShrink={0}
      w={{ base: '100%', sm: 'auto' }}
      style={{ boxShadow: `0 0 22px ${accentColor}44` }}
      onClick={() => tracking.event({ action: 'click_get_started' })}
      asChild
    >
      <Link to="/{-$locale}/sign-up">{buttonLabel}</Link>
    </Button>
  </Flex>
);
